import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { Project } from '../../../helpers/types';
import {
  CreateProjectPayload,
  projectsApi,
} from '../../../services/projectsApi';
import { notificationsActions } from '../../Notifications/slice';
import { projectsActions as actions } from '.';

function* handleFetch() {
  try {
    const data = (yield call(projectsApi.list)) as Project[];
    yield put(actions.fetchSuccess(data));
  } catch (error) {
    const message =
      error instanceof Error ? error.message : 'Failed to load projects';
    yield put(actions.fetchFailure(message));
    yield put(
      notificationsActions.setNotification({ message, type: 'error' }),
    );
  }
}

function* handleCreate(action: PayloadAction<CreateProjectPayload>) {
  try {
    const data = (yield call(
      projectsApi.create,
      action.payload,
    )) as Project;
    yield put(actions.createSuccess(data));
    yield put(
      notificationsActions.setNotification({
        message: 'Project created',
        type: 'success',
      }),
    );
  } catch (error) {
    const message =
      error instanceof Error ? error.message : 'Failed to create project';
    yield put(actions.createFailure());
    yield put(
      notificationsActions.setNotification({ message, type: 'error' }),
    );
  }
}

function* handleDelete(action: PayloadAction<string>) {
  try {
    yield call(projectsApi.remove, action.payload);
    yield put(actions.deleteSuccess(action.payload));
    yield put(
      notificationsActions.setNotification({
        message: 'Project deleted',
        type: 'success',
      }),
    );
  } catch (error) {
    const message =
      error instanceof Error ? error.message : 'Failed to delete project';
    yield put(
      notificationsActions.setNotification({ message, type: 'error' }),
    );
  }
}

export function* projectsSaga() {
  yield takeLatest(actions.fetchRequest.type, handleFetch);
  yield takeLatest(actions.createRequest.type, handleCreate);
  yield takeLatest(actions.deleteRequest.type, handleDelete);
}
